(() => {
  const root = document.getElementById('go-collection-root');
  if (!root) return;

  const sectionId = root.dataset.goSectionId;
  const gridContainerSel = '#ProductGridContainer';
  const facetsSel = '#FacetFiltersForm'; // Be Yours / OS2.0 themes typically use this id
  const filterbarSel = '.go-filterbar';

  const setLoading = (on) => {
    document.documentElement.classList.toggle('go-loading', !!on);
    const fb = document.querySelector(filterbarSel);
    if (fb) fb.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  const fetchSectionHTML = async (url) => {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);

    const res = await fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) throw new Error('Fetch failed');
    return await res.text();
  };

  const swapFromHTML = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newGrid = doc.querySelector(gridContainerSel);
    const curGrid = document.querySelector(gridContainerSel);
    if (newGrid && curGrid) curGrid.innerHTML = newGrid.innerHTML;

    const newFacets = doc.querySelector(facetsSel);
    const curFacets = document.querySelector(facetsSel);
    if (newFacets && curFacets) curFacets.innerHTML = newFacets.innerHTML;

    // Re-run active-state paint (your pills/toggles)
    document.dispatchEvent(new CustomEvent('go:filters:updated'));
  };

  const navigate = async (url, push = true) => {
    try {
      setLoading(true);
      const html = await fetchSectionHTML(url);
      swapFromHTML(html);
      if (push) history.pushState({}, '', url);
    } catch (e) {
      // Fallback: if anything goes wrong, do a normal navigation
      window.location.href = url;
    } finally {
      setLoading(false);
    }
  };

  // Intercept clicks in your custom filterbar (Strength/Formula links)
  document.addEventListener('click', (e) => {
    const a = e.target.closest(`${filterbarSel} a`);
    if (!a) return;

    const href = a.getAttribute('href');
    if (!href || href.startsWith('#')) return;

    // Let cmd/ctrl-click open a new tab normally
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    e.preventDefault();
    navigate(href, true);
  });

  // Back/forward support
  window.addEventListener('popstate', () => navigate(window.location.href, false));
})();
